import { useTranslation } from "react-i18next";
import { useRemoteMutation } from "../../useRemote/useRemoteMutation";
import { RemoteApiError } from "../../useRemote/types";

export function useRemoteUpdateRoomlayout() {
  const { t } = useTranslation();

  return useRemoteMutation<void, RemoteApiError, FormData>({
    key: ["update-room-layouts"],
    url: `/room-layouts`,
    method: "post",
    snackbarTextOnSuccess: t("Successfully updated a roomlayout"),
    snackbarTextOnFail: t(`There was a server error`)
  });
}
